import { Box } from "@chakra-ui/react"

import Loader from "../../../shared/Loader"

const ModelViewer3dModal = ({ Modal, modelUrlsString, handleClose }) => {
  return (
    <Modal
      /* Style the container div for responsiveness */
      modalContentStyleProps={{
        minWidth: { base: "100%", sm: "90%" },
        height: { base: "100%", sm: "90%" },
        m: "0",
        px: { base: "4", sm: "8" },
        pb: { base: "4", sm: "8" },
        pt: { base: "12", sm: "9.5" },
        overflow: "hidden",
      }}
      customOnClose={handleClose}
    >
      {/* Position the loader absolutely so it doesn't mess up with the 3D model div positioning */}
      <Box position="absolute" className="model-spinner" left="50%" top="50%" transform="translate(-50%, -50%)">
        <Loader />
      </Box>
      {/* Just leave the 3D model to take the full width and height of the container */}
      <Box height="100%" className="online-3d-viewer" model={modelUrlsString} cursor="pointer"></Box>
    </Modal>
  )
}

export default ModelViewer3dModal
